import useAuth from '@app/auth/use-auth';
import { PageHeader } from '@app/components/layout/page/components/page-header';
import Page from '@app/components/layout/page/page';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { pcfRoutes } from './pcf-routes';

export default function PcfAccessPage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { features } = user!;

  useEffect(() => {
    if (features.pcf) {
      navigate(pcfRoutes.PRODUCT_DASHBOARD);
    }
  }, [features, navigate]);

  return (
    <Page name="Access product assessments">
      <PageHeader name="Product assessments" includeBreadcrumb={false} />
    </Page>
  );
}
